import * as moment from 'moment';

export enum MatchResult {
    Draw,
    Win,
    Loss
}

export class Match {
    id: number;
    location: string;
    country: string;
    description: string;
    stage: number;
    awayTeamScore: number;
    leagueId: number;
    leagueName: string;
    matchId: number;
    awayTeamId: number;
    awayTeamName: string;
    staticId: number;
    homeTeamScore: number;
    matchDate: moment.Moment;
    halftimeScore: string;
    season: string;
    homeTeamId: number;
    homeTeamName: string;
    city: string;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/match.model.ts